import { Helmet } from 'react-helmet';
import {
    Avatar,
    Box, Button, Card, CardContent,
    Container, Divider,
    Grid, Tab, Tabs, Collapse, Typography, tableCellClasses, ClickAwayListener, TextField, FormGroup, FormControlLabel, Checkbox, Paper, Grow, Popper, MenuList
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import cssVariables from "../../../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emty from "../../../../assets/images/emty.png";
import { ReactComponent as BtnFilter } from "../../../../assets/images/btn-filter.svg";
import { useParams } from "react-router-dom";
import { ReactComponent as DraftIcon } from "../../../../assets/images/iconStatus/draft.svg";
import { ReactComponent as ApprovedIcon } from "../../../../assets/images/iconStatus/approved.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/edit.svg";
import { ReactComponent as StartIcon } from "../../../../assets/images/start.svg";
import { ReactComponent as SaveIcon } from "../../../../assets/images/save.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/images/cancel.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { ReactComponent as TeamIcon } from "../../../../assets/images/people.svg";
import { ReactComponent as InnovationIcon } from "../../../../assets/images/position-icon.svg";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/circle-fill-error.svg";
import { ReactComponent as Signoff } from "../../../../assets/images/signoff.svg";
import { ReactComponent as Megaphone } from "../../../../assets/images/megaphone.svg";
import { ReactComponent as Pass } from "../../../../assets/images/pass.svg";
import { ReactComponent as NotPass } from "../../../../assets/images/notPass.svg";
import { ReactComponent as Extension } from "../../../../assets/images/extension.svg";
import DialogSendToApprove from "../../../../components/kpi/DialogSendToApprove";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import ConfirmRejectPerformanceEvaliation from "../ConfirmRejectPerformanceEvaliation";
import MessageDialogRejectPerformanceEvaliation from "../MessageDialogRejectPerformanceEvaliation";
import Congrtulations from "../../../../components/kpi/Congrtulations";
import TotalAchievements from "./TotalAchievements";
import RatingSummary from "./RatingSummary";
import Stack from '@mui/material/Stack';
import file from "../../../../assets/images/home/file.svg";
import signatures from "../../../../assets/images/home/signatures.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/images/home/chevron-down.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/images/home/chevron-up.svg";
import { ReactComponent as Checks } from "../../../../assets/icons/checks.svg";
import * as Util from "../../../../services/global.service";
import blockSignatures from "../../../../assets/images/signatures.svg";
import IndividualTab from "../IndividualTab";
import evaluateService from "../../../../services/evaluate.service";
import ListData from "./ListData"
import Result from "./Result"
import MoreInfo from "../../../../components/kpi/MoreInfo";
import { ReactComponent as MoreInfoIcon } from "../../../../assets/images/more-info.svg";
import { ReactComponent as DateIcon } from "../../../../assets/images/date-work.svg";
import { object } from 'prop-types';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
// swiper core styles
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'

// modules styles
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'
import { borderRadius, width } from '@mui/system';

// import required modules
// import { Pagination, Navigation } from "swiper";
SwiperCore.use([Navigation, Pagination]);
const styles = {
    path: {
        color: "#68717A",
    },
    paDatasEvaluation: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        backgroundColor: "#fff",
        height: "220px",
        boxShadow: "0px 0px 5px rgb(0 0 0 / 10%)",
        borderRadius: "10px",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    },
    paperContainer: {
        backgroundImage: `url(${blockSignatures})`,
        width: "100%",
        minHeight: 160,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "550px",
    },

};

const PerformanceEvaliationDetail = () => {
    const _ = require('lodash');

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const [value, setValue] = React.useState('');
    const [valueSerial, setValueSerial] = React.useState('');
    // const [valueType, setValueType] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [openConfirmRejectPerformanceEvaliation, setOpenConfirmRejectPerformanceEvaliation] = React.useState(false);
    const [openMessageDialogRejectPerformanceEvaliation, setOpenMessageDialogRejectPerformanceEvaliation] = React.useState(false);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [openMenus, setOpenMenus] = React.useState(false);
    const [openMenusCompetency, setOpenMenusCompetency] = React.useState(false);
    const [reset, setReset] = React.useState(false);
    const anchorRef = React.useRef(null);
    const anchorRefCompetency = React.useRef(null);
    const [workloadFormSelect, setWorkloadForm] = React.useState([
        {
            description: "Performance Evaluation of 2020-2021",
            serial: "1",
        },
        {
            description: "Performance Evaluation of 2019-2020",
            serial: "2",
        }
    ]);
    const [Datas, setData] = React.useState([]);
    const [mainData, setMainData] = React.useState([]);
    const [dataEvaluate, setDataEvaluate] = React.useState([]);
    // redux state
    const [checkeNextAction, setCheckeNextAction] = React.useState({});
    const [isPromotionChecked, setPromotionChecked] = React.useState(false);
    const [statusEdit, setSstatusEdit] = React.useState(false);
    const [statusSend, setSstatusSend] = React.useState(false);
    const [evaluation, setEvaluation] = React.useState(true);
    const [update, setUpdate] = React.useState(false);
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [isSuccessRejectDialogOpen, openSuccessRejectDialog] = React.useState(false);
    const [isSuccessSignoffDialogOpen, openSuccessSignoffDialogOpen] = React.useState(false);
    const [isConfirmCancelDialogOpen, openConfirmCancelDialog] = React.useState(false);
    const [isSuccessCancelDialogOpen, openSuccessCancelDialog] = React.useState(false);
    const [dataFormSave, setdataFormSave] = React.useState({
        // form_evaluate: serial,
        // editor: "",
        // goal: [],
        // competency: [],
        // idp: []
    });
    const [actSave, setActSave] = React.useState(false);
    const [submitError, setSubmitError] = React.useState(false);
    const [showTypeError, setShowTypeError] = React.useState({});
    const [employeeSignatures, setEmployeeSignatures] = React.useState("");
    const [commentPromotion, setCommentPromotion] = React.useState("");
    const [evaluatorSignatures, setEvaluatorSignatures] = React.useState("");
    const language = localStorage.getItem("lang");
    const [editPromotion, setEditPromotion] = React.useState(false);
    const [checkDatas, setCheckDatas] = React.useState(false);

    const [DatasEvaluation, setDataEvaluation] = React.useState({});
    const [checkFilter, setCheckFilter] = React.useState({
        goalsSuccess: true,
        goalsError: true,
        goalsNoGap: true,
    });
    const [checkFilterCompetency, setCheckFilterCompetency] = React.useState({
        goalsSuccess: true,
        goalsError: true,
        goalsNoGap: true,
    });
    const [signOffExtend, setSignOffExtend] = React.useState(false);
    const [signOff, setSignOff] = React.useState(false);
    const onSetSignOffExtend = () => {
        setSignOffExtend(!signOffExtend)
    };
    const onSetSignOff = () => {
        setSignOff(!signOff)
    };

    let callBack = async (data, type, workflow_section) => {
        if (Object.keys(dataFormSave).length > 0) {
            dataFormSave.editor = dataEvaluate?.editor === "self" ? "self" : dataEvaluate?.editor === "evaluator" ? "evaluator" : ""
            if (Util.formatData(workflow_section, false) !== false && Util.formatData(dataFormSave?.workflow_section, false) === false) {
                dataFormSave.workflow_section = workflow_section
            }
            if (type === "probation_result") {
                dataFormSave[type] = data
            } else {
                if (dataFormSave[type] !== undefined && dataFormSave[type].length > 0) {
                    for (let idex = 0; idex <= data.length - 1; idex++) {
                        let check = dataFormSave[type].filter((rs) => rs?.serial === data[idex]?.serial)
                        if (check.length > 0) {
                            for (let index = 0; index <= dataFormSave[type].length - 1; index++) {
                                if (dataFormSave[type][index]?.serial === data[idex]?.serial) {
                                    dataFormSave[type][index] = data[idex]
                                }
                            }
                        } else {
                            dataFormSave[type].push(data[idex])
                        }
                    }
                } else {
                    dataFormSave[type] = data
                }
            }
            if (update === false) {
                setUpdate(true)
            }
        } else {
            let setDataForm = {
                "form_evaluate": serial,
                "editor": dataEvaluate?.editor === "self" ? "self" : dataEvaluate?.editor === "evaluator" ? "evaluator" : "",
                "goal": [
                ],
                "competency": [
                ],
                "idp": [
                ],
                "probation": [
                ],
                "probation_result": [
                ]
            }
            if (Util.formatData(workflow_section, false) !== false) {
                setDataForm.workflow_section = workflow_section
            }
            setDataForm[type] = data
            await setdataFormSave(setDataForm)
        }

    }

    const onHideEvaluationChange = () => {
        setEvaluation(!evaluation);
    };
    const onPromotionChange = () => {
        if (statusEdit && checkeNextAction?.options?.promote?.can_edit === true) {
            setPromotionChecked(!isPromotionChecked)
        }
    }

    const checkDataSave = () => {
        let sumData = 0
        if (Util.formatData(dataFormSave?.goal, false) !== false && dataFormSave?.goal.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.competency, false) !== false && dataFormSave?.competency.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.idp, false) !== false && dataFormSave?.idp.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.probation, false) !== false && dataFormSave?.probation.length > 0) {
            sumData = sumData + 1
        }
        if (Util.formatData(dataFormSave?.probation_result, false) !== false && dataFormSave?.probation_result.length > 0) {
            sumData = sumData + 1
        }
        if (editPromotion) {
            sumData = sumData + 1
        }
        if (sumData > 0) {
            return false;
        } else {
            return true;
        }
    };

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));
    const tabs = _.groupBy(DatasEvaluation.rubrics, function (loRow) {
        return loRow.rubricCat;
    })

    useEffect(() => {
        getDetail()
        // dataRating()
    }, []);


    const getDetail = () => {
        evaluateService.getEvaliationDetail(serial).then(
            async (rs) => {

                let list_evaluate_component = rs?.data?.evaluate_component

                if (rs?.data?.evaluate_component && rs?.data?.evaluate_component.length > 0) {
                    for (const component of rs?.data?.evaluate_component) {
                        let idx = _.findIndex(list_evaluate_component, { type: component.type })
                        if (idx !== -1) {
                            if (component.type !== 'idp' && component.type !== 'result') {
                                const respComponent = await evaluateService.getEvaliationComponent(serial, component.type)
                                //console.log('Component', component.type, respComponent)
                                if (respComponent?.evaluate_component) list_evaluate_component[idx] = respComponent?.evaluate_component
                            } else {
                                //list_evaluate_component.push(component)
                            }
                        }
                    }
                }

                //console.log('list_evaluate_component', list_evaluate_component)

                //setMainData(rs?.data?.evaluate_component)
                //setData(rs?.data?.evaluate_component)

                setMainData(list_evaluate_component)
                setData(list_evaluate_component)

                if (Util.formatData(rs?.data?.evaluate_component, []).length > 0) {
                    setValue(rs?.data?.evaluate_component[0]?.type === "custom" ? rs?.data?.evaluate_component[0]?.type + rs?.data?.evaluate_component[0]?.seq : rs?.data?.evaluate_component[0]?.type)
                }
                setDataEvaluate(rs?.data)
                showError(rs?.data.evaluate_component, rs?.data)
                let checkIsCurrent = rs.data.evaluate_step.step.find(item => item?.is_current === true)
                // let checkIsCurrent = rs.data.evaluate_step.step[1]
                setCheckeNextAction(checkIsCurrent)
            }).catch(() => {

            })
    }
    useEffect(() => {
        if (isSuccessSaveDialogOpen === false && actSave === true) {
            getDetail()
            // dataRating()
        }
    }, [isSuccessSaveDialogOpen]);
    useEffect(() => {
        setDateWork()
        let filterData = Util.formatData(dataEvaluate?.evaluate_step?.step, []).filter(item => item.type === "signoff" && item.is_current === true)
        if (filterData.length > 0) {
            if (Util.formatData(dataEvaluate?.evaluate_step?.sign_off_extend, false) !== false) {
                setSignOffExtend(true)
                setEvaluation(false)
                setSignOff(false)
            } else if (Util.formatData(dataEvaluate?.evaluate_step?.sign_off, false) !== false) {
                setSignOffExtend(false)
                setEvaluation(false)
                setSignOff(true)
            } else {
                setSignOffExtend(false)
                setEvaluation(true)
                setSignOff(false)
            }
        } else {
            setSignOffExtend(false)
            setEvaluation(true)
            setSignOff(false)
        }
        display()
    }, [dataEvaluate]);
    let closeSuccessSaveDialog = async () => {
        await setActSave(true)
        setSstatusEdit(false)
        openSuccessSaveDialog(false)
        setUpdate(false)
        setdataFormSave({
            // form_evaluate: serial,
            // editor: "",
            // goal: [],
            // competency: [],
            // idp: []
        })
        getDetail()
    }

    let closeRejectSuccess = () => {
        openSuccessRejectDialog(false)
        getDetail()
    }

    let showError = (data, allData) => {
        if (Util.formatData(data, false) !== false && data.length > 0) {
            let checkError = false
            let typeError = {}
            for (let index = 0; index <= data.length - 1; index++) {
                if (data[index]?.type === "result" && allData?.editor === "evaluator") {
                    if (typeError[data[index]?.type] !== true && Util.formatData(data[index].list_item, []).length > 0) {
                        for (let id = 0; id <= data[index].list_item.length - 1; id++) {
                            if (typeError[data[index]?.type] !== true && Util.formatData(data[index].list_item[id]?.result, false) !== false) {
                                if (Util.formatData(data[index].list_item[id]?.result, "") === "extend") {
                                    if (Util.formatData(data[index].list_item[id]?.extend_date, false) !== false) {

                                    } else {
                                        typeError[data[index]?.type] = true
                                        checkError = true
                                    }
                                }
                                if (Util.formatData(data[index].list_item[id]?.result, "") === "not_pass") {
                                    if (Util.formatData(data[index].list_item[id]?.comment, false) !== false) {

                                    } else {
                                        typeError[data[index]?.type] = true
                                        checkError = true
                                    }
                                }
                            } else {
                                typeError[data[index]?.type] = true
                                checkError = true
                            }
                        }
                    }
                } else {
                    if (typeError[data[index]?.type] !== true && Util.formatData(data[index]?.list_item, false) !== false && data[index]?.list_item.length > 0) {
                        for (let id = 0; id <= data[index].list_item.length - 1; id++) {
                            if (typeError[data[index]?.type] !== true && data[index]?.type === "goal" && Util.formatData(data[index].list_item[id]?.goal_items, false) !== false && data[index].list_item[id]?.goal_items.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].goal_items.length - 1; order++) {
                                    if (Util.formatData(data[index].list_item[id].goal_items[order]?.evaluate_probation_rating, false) !== false) {
                                        let filterData = data[index].list_item[id].goal_items[order]?.evaluate_probation_rating.filter((rs) => rs?.evaluator?.workflow_section?.is_current === true)
                                        if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "self") {
                                            if (Util.formatData(filterData[0]?.self?.rating?.serial, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_employee_comment === true) {
                                                if (Util.formatData(filterData[0]?.self?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        } else if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "evaluator") {
                                            if (Util.formatData(filterData[0]?.evaluator?.rating?.serial, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_evaluator_comment === true) {
                                                if (Util.formatData(filterData[0]?.evaluator?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        }
                                    }
                                }
                            } else if (typeError[data[index]?.type] !== true && data[index]?.type === "probation" && Util.formatData(data[index].list_item[id]?.probation_item, false) !== false && data[index].list_item[id]?.probation_item.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].probation_item.length - 1; order++) {
                                    if (Util.formatData(data[index].list_item[id].probation_item[order]?.evaluate_probation_rating, false) !== false) {
                                        let filterData = data[index].list_item[id].probation_item[order]?.evaluate_probation_rating.filter((rs) => rs?.evaluator?.workflow_section?.is_current === true)
                                        if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "self") {
                                            if (Util.formatData(filterData[0]?.self?.rating?.serial, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_employee_comment === true) {
                                                if (Util.formatData(filterData[0]?.self?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        } else if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "evaluator") {
                                            if (Util.formatData(filterData[0]?.evaluator?.rating?.serial, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_evaluator_comment === true) {
                                                if (Util.formatData(filterData[0]?.evaluator?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        }
                                    }
                                }
                            } else if (typeError[data[index]?.type] !== true && data[index]?.type === "competency" && Util.formatData(data[index].list_item[id]?.competency_items, false) !== false && data[index].list_item[id]?.competency_items.length > 0) {
                                for (let order = 0; order <= data[index].list_item[id].competency_items.length - 1; order++) {
                                    if (Util.formatData(data[index].list_item[id].competency_items[order]?.evaluate_probation_rating, false) !== false) {
                                        let filterData = data[index].list_item[id].competency_items[order]?.evaluate_probation_rating.filter((rs) => rs?.evaluator?.workflow_section?.is_current === true)
                                        if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "self") {
                                            if (Util.formatData(filterData[0]?.self?.rating?.value, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_employee_comment === true) {
                                                if (Util.formatData(filterData[0]?.self?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        } else if (typeError[data[index]?.type] !== true && filterData.length > 0 && allData?.editor === "evaluator") {
                                            if (Util.formatData(filterData[0]?.evaluator?.rating?.value, false) === false) {
                                                typeError[data[index]?.type] = true
                                                checkError = true
                                            }
                                            if (data[index]?.require_evaluator_comment === true) {
                                                if (Util.formatData(filterData[0]?.evaluator?.comment, false) === false) {
                                                    typeError[data[index]?.type] = true
                                                    checkError = true
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setShowTypeError(typeError)
            setSubmitError(checkError)
        }
    }

    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest(".tooltip") === null) {
                setOpen(false)
                setValueSerial("")
                // setValueType("")
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    });

    let actionReject = (data) => {
        setOpenConfirmRejectPerformanceEvaliation(false)
        evaluateService.rejectForm({
            evaluate_id: serial,
            remark: Util.formatData(data?.description, "")
        }).then(
            (response) => {
                openSuccessRejectDialog(true)
            },
        ).catch(() => {
            setOpenMessageDialogRejectPerformanceEvaliation(true)
        })
    }

    let tryAgain = (data) => {
        setOpenConfirmRejectPerformanceEvaliation(true)
        setOpenMessageDialogRejectPerformanceEvaliation(false)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const useStyles = makeStyles({
        iconContainer: {
            width: 48,
            height: 48,
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        root: {
            'border-width': 0,
            'padding-left': 0,
            [`&.${tableCellClasses.body}`]: {
                'border-width': 0,
                'padding-left': 0,
            }
        },
        tab: {
            fontSize: "16px !important",
            fontWeight: "400 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            },
            '&.MuiTab-root': {
                "text-transform": "none"
            }
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        containerAchievements: {
            background: "#FAFAFA",
            border: "1px solid #DADADA",
            borderRadius: "4px",
            maxWidth: "320px",
            width: "100%"
        },
        statusBadge: {
            maxWidth: "130px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
            background: ""
        },
        processBgYellow: {
            background: "#EFB76D26",
        },
        processTextYellow: {
            color: "#EFB76D",
        },
        processBgOrange: {
            background: "#F2802626",
        },
        processTextOrange: {
            color: "#F28026",
        },
        processBgGreen: {
            background: "#5DA19626",
        },
        processTextGreen: {
            color: "#5DA196",
        },
        processBgRed: {
            background: "#CC605826",
        },
        processTextRed: {
            color: "#CC6058",
        },
        processBgGrary: {
            background: "#82828226",
        },
        processTextGrary: {
            color: "#828282",
        },
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
        btnDisabled: {
            '& .Mui-disabled': {
                color: "#FFFFFF !important",
                backgroundColor: "#BABABA !important",
                border: "none !important",
                '& svg > path': {
                    fill: '#FFFFFF !important'
                },
                '& svg > g > path': {
                    fill: '#FFFFFF !important'
                },
            }
        },
        btnNotDisabled: {
            paddingRight: "30px"
        },
        swiperStyles: {
            '& .swiper-container': {
                position: "unset !important",
                width: "100%"
            },
            '& div > .swiper-wrapper': {
                position: "unset !important"
            },
            '& div > .swiper-slide': {
                display: "flex",
                alignItems: "center"
            },
            '& div > .swiper-button-next, .swiper-button-prev': {
                "background- color": "white",
                "background- color": "rgba(255, 255, 255, 0.5)",
                right: "20px",
                padding: "12px",
                color: "#5DA196 !important",
                fill: "#5DA196 !important",
                stroke: "#5DA196 !important",
                border: "1px solid #5DA196",
                borderRadius: "3px",
                height: "20px",
                width: "20px",
                top: "75px",
            },
            '& div > .swiper-button-prev': {
                right: "60px !important",
                left: "auto !important"
            },
            '& div >.swiper-button-next:after,.swiper-button-prev:after': {
                "font-size": "12px"
            },
            '& div > .swiper-pagination, .swiper-pagination-fraction': {
                bottom: "auto",
                left: "auto",
                width: "auto",
                right: "100px",
                top: "55px",
                "font-family": "'Kanit'",
                "font-size": "14px",
                "line-height": "21px",
                "font-weight": 400,
                '& .swiper-pagination-current': {
                    color: "#5DA196 !important"
                },
            },
        },
    })
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const onStart = (serial) => {
        evaluateService.requestEvaluationStart({
            evaluate_id: serial,
        }).then(
            (response) => {
                getDetail()
            },
        ).catch(() => {
            // handleOpenFailedMessageDialog()
        })
    }
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const dateFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
            })
            return dateTH
        }
    }
    const dateDayFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
                day: 'numeric',
            })
            return dateTH
        }
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openMenu) {
                setOpenMenu(false)
            }
            if (openMenus) {
                setOpenMenus(false)
            }
            if (openMenusCompetency) {
                setOpenMenusCompetency(false)
            }
        }
    }
    const statusOpen = (data) => {
        setOpenMenu(data)
    }
    const onEdit = () => {
        setSstatusEdit(true)
        setReset(true)
        setdataFormSave({})
        // setStatusValidate(false)
    }
    const onCancel = () => {
        handleConfirmCancelDialog(true)
    }
    const handleConfirmCancelDialog = (val) => {
        openConfirmCancelDialog(val)
    };
    const onSave = () => {
        let dataForms = JSON.parse(JSON.stringify(dataFormSave))
        if (Object.keys(dataForms).length < 1) {
            dataForms = {
                form_evaluate: serial,
                editor: "",
                goal: [],
                competency: [],
                idp: []
            }
        }
        dataForms.editor = dataEvaluate.editor === "self" ? "self" : dataEvaluate.editor === "evaluator" ? "evaluator" : ""
        evaluateService.saveEvaliationDetail(dataForms).then((rs) => {
            openSuccessSaveDialog(true)
        }).catch((err) => { })
        if (statusSend === false) {
            setSstatusSend(true)
        }
    }
    const handleConfirmCancelList = () => {
        setUpdate(false)
        setdataFormSave({
            // form_evaluate: serial,
            // editor: "",
            // goal: [],
            // competency: [],
            // idp: []
        })
        handleConfirmCancelDialog(false)
        openSuccessCancelDialog(true)
        setSstatusEdit(false)
        getDetail()
        // setCheckAdd(!checkAdd)
        // if (statusSave) {
        // setStatusValidate(true)
        // }
    };

    const changeReset = () => {
        setReset(false)
    };
    const handleToggle = () => {
        setOpenMenus(!openMenu)
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpenMenus(false);
    };
    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenMenus(false);
        } else if (event.key === 'Escape') {
            setOpenMenus(false);
        }
    }
    const changeGapGolas = (type, datas) => {
        let data = JSON.parse(JSON.stringify(checkFilter))
        let dataFild = JSON.parse(JSON.stringify(datas))
        let dataMain = JSON.parse(JSON.stringify(mainData))
        let index = dataMain.map(object => object?.type === dataFild?.type).indexOf(true)
        if (type === "all") {
            let getObjectKey = Object.keys(data)
            let check = getObjectKey.filter((rs) => data[rs] === true)
            let sumData = {}
            if (check.length !== getObjectKey.length) {
                sumData = {
                    goalsSuccess: true,
                    goalsError: true,
                    goalsNoGap: true,
                }
            } else {
                sumData = {
                    goalsSuccess: false,
                    goalsError: false,
                    goalsNoGap: false,
                }
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        dataMain[index].list_item[id].goal_items = []
                    }
                } else {
                    dataMain[index].list_item = []
                }
            }
            setData(dataMain)
            setCheckFilter(sumData)
        } else {
            data[type] = !checkFilter[type]
            if (data.goalsSuccess === true && data.goalsError === true && data.goalsNoGap === true) {
            } else if (data.goalsSuccess === false && data.goalsError === false && data.goalsNoGap === false) {
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        dataMain[index].list_item[id].goal_items = []
                    }
                } else {
                    dataMain[index].list_item = []
                }
            } else {
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        if (data.goalsSuccess === true && data.goalsError === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) !== 0)
                        } else if (data.goalsError === true && data.goalsNoGap === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) <= 0)
                        } else if (data.goalsNoGap === true && data.goalsSuccess === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) >= 0)
                        } else if (data.goalsSuccess === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) > 0)
                        } else if (data.goalsError === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) < 0)
                        } else if (data.goalsNoGap === true) {
                            dataMain[index].list_item[id].goal_items = dataMain[index].list_item[id].goal_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) === 0)
                        }
                    }
                } else {
                    dataMain[index].list_item = []
                }
            }
            setData(dataMain)
            setCheckFilter(data)
        }
    };

    let checkAll = () => {
        let check = true
        let data = checkFilter
        let getObjectKey = Object.keys(data)
        let checks = getObjectKey.filter((rs) => data[rs] === true)
        if (checks.length !== getObjectKey.length) {
            check = false
        } else {
            check = true
        }
        return check;
    }
    let checkIndeterminate = () => {
        let check = true
        let data = checkFilter
        let getObjectKey = Object.keys(data)
        let checksTrue = getObjectKey.filter((rs) => data[rs] === true)
        let checksFalse = getObjectKey.filter((rs) => data[rs] === false)
        if (getObjectKey.length !== checksTrue.length && getObjectKey.length !== checksFalse.length) {
            check = true
        } else {
            check = false
        }
        return check;
    }
    const handleToggleCompetency = () => {
        setOpenMenusCompetency(!openMenu)
    };
    const handleCloseCompetency = (event) => {
        if (anchorRefCompetency.current && anchorRefCompetency.current.contains(event.target)) {
            return;
        }

        setOpenMenusCompetency(false);
    };
    function handleListKeyDownCompetency(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenMenusCompetency(false);
        } else if (event.key === 'Escape') {
            setOpenMenusCompetency(false);
        }
    }
    const changeGapGolasCompetency = (type, datas) => {
        let data = JSON.parse(JSON.stringify(checkFilterCompetency))
        let dataFild = JSON.parse(JSON.stringify(datas))
        let dataMain = JSON.parse(JSON.stringify(mainData))
        let index = dataMain.map(object => object?.type === dataFild?.type).indexOf(true)
        if (type === "all") {
            let getObjectKey = Object.keys(data)
            let check = getObjectKey.filter((rs) => data[rs] === true)
            let sumData = {}
            if (check.length !== getObjectKey.length) {
                sumData = {
                    goalsSuccess: true,
                    goalsError: true,
                    goalsNoGap: true,
                }
            } else {
                sumData = {
                    goalsSuccess: false,
                    goalsError: false,
                    goalsNoGap: false,
                }
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        dataMain[index].list_item[id].competency_items = []
                    }
                } else {
                    dataMain[index].list_item = []
                }
            }
            setData(dataMain)
            setCheckFilterCompetency(sumData)
        } else {
            data[type] = !checkFilterCompetency[type]
            if (data.goalsSuccess === true && data.goalsError === true && data.goalsNoGap === true) {
            } else if (data.goalsSuccess === false && data.goalsError === false && data.goalsNoGap === false) {
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        dataMain[index].list_item[id].competency_items = []
                    }
                } else {
                    dataMain[index].list_item = []
                }
            } else {
                if (dataMain[index]?.list_item !== undefined && dataMain[index]?.list_item !== null && dataMain[index].list_item.length > 0) {
                    for (let id = 0; id <= dataMain[index].list_item.length - 1; id++) {
                        if (data.goalsSuccess === true && data.goalsError === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) !== 0)
                        } else if (data.goalsError === true && data.goalsNoGap === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) <= 0)
                        } else if (data.goalsNoGap === true && data.goalsSuccess === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) >= 0)
                        } else if (data.goalsSuccess === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) > 0)
                        } else if (data.goalsError === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) < 0)
                        } else if (data.goalsNoGap === true) {
                            dataMain[index].list_item[id].competency_items = dataMain[index].list_item[id].competency_items.filter((rs) => isNaN(Number(rs?.gap)) === false && Number(rs?.gap) === 0)
                        }
                    }
                } else {
                    dataMain[index].list_item = []
                }
            }
            setData(dataMain)
            setCheckFilterCompetency(data)
        }
    };

    let checkAllCompetency = () => {
        let check = true
        let data = checkFilterCompetency
        let getObjectKey = Object.keys(data)
        let checks = getObjectKey.filter((rs) => data[rs] === true)
        if (checks.length !== getObjectKey.length) {
            check = false
        } else {
            check = true
        }
        return check;
    }
    let checkIndeterminateCompetency = () => {
        let check = true
        let data = checkFilterCompetency
        let getObjectKey = Object.keys(data)
        let checksTrue = getObjectKey.filter((rs) => data[rs] === true)
        let checksFalse = getObjectKey.filter((rs) => data[rs] === false)
        if (getObjectKey.length !== checksTrue.length && getObjectKey.length !== checksFalse.length) {
            check = true
        } else {
            check = false
        }
        return check;
    }
    const onClickSignoff = () => {
        evaluateService.submitForm({
            evaluate_id: serial,
        }).then(
            (response) => {
                openSuccessSignoffDialogOpen(true)
                setActSave(false)
            },
        ).catch(() => {
        })
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        onClickSignoff()
    };
    const handleCancel = () => {
        if (statusSend === false) {
            setSstatusSend(true)
        }
        setDiscardDialog(true)
    }
    const handleSignoffDialog = (value) => {
        openSuccessSignoffDialogOpen(value)
        getDetail()
    }
    const [openMoreInfo, setOpenMoreInfo] = React.useState(false);
    const onOpenMoreInfo = () => {
        setOpenMoreInfo(true)
    }
    const onCloseMoreInfo = () => {
        setOpenMoreInfo(false)
    }
    const [datePosition, setDatePosition] = React.useState("");
    const [dateEmpoloyee, setDateEmpoloyee] = React.useState("");
    const setDateWork = () => {
        if (Util.formatData(dataEvaluate?.employee?.pos_exp, false) !== false && Util.formatData(dataEvaluate?.employee?.pos_exp, false) !== false) {
            let dataPositionDate = dataEvaluate?.employee?.pos_exp
            let dataEmpolyeeDate = dataEvaluate?.employee?.emp_exp
            if (language === "en-US") {
                dataPositionDate = dataPositionDate.replace('y', 'y ')
                dataPositionDate = dataPositionDate.replace('m', 'm ')
                // dataPositionDate = dataPositionDate.replace('d', 'd ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            } else {
                dataPositionDate = dataPositionDate.replace('y', ' ปี ')
                dataPositionDate = dataPositionDate.replace('m', ' เดือน ')
                dataPositionDate = dataPositionDate.replace('d', ' วัน')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            }

        }
    }

    let getWidth = (data) => {
        let widths = 235 + (120 * data)
        let widthP = (widths / 1383) * 100
        return widthP
    }
    let getFirstWidth = (data) => {
        let widths = 180 + (120 * data)
        let widthP = (180 / widths) * 100
        return widthP
    }
    let getNextWidth = (data) => {
        let widths = 180 + (120 * data)
        let widthP = (120 / widths) * 100
        return widthP
    }
    const [dataDisplay, setDataDisplay] = React.useState("");
    const display = () => {
        let dataType = Util.formatData(dataEvaluate?.evaluate_component, []).filter((rs) => rs.type === "result")
        if (dataType.length > 0 && Util.formatData(dataType[0]?.list_item, []).length > 0) {
            let dataNotPass = Util.formatData(dataType[0].list_item, []).filter((rs) => rs.result === "not_pass")
            if (dataNotPass.length > 0) {
                setDataDisplay(dataNotPass[0])
            } else {
                setDataDisplay(dataType[0].list_item[0])
            }
        }
    }
    return (
        <Box onScroll={onScroll} className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }} >
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        {dataEvaluate?.editor === "other" ?
                            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("label.home")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/inbox')}>{t("label.inbox")}</span> / <span style={styles.end} >{dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ? dataEvaluate?.form?.name : "-"}</span></Typography>
                            : dataEvaluate?.editor === "evaluator" ?
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("label.home")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/performance-evaluation')}>{t("sidebar.label.evaluationManage")}</span> / <span style={styles.end} >{dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ? dataEvaluate?.form?.name : "-"}</span></Typography>
                                :
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("label.home")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/evaluation')}>{t("sidebar.label.evaluation")}</span> / <span style={styles.end} >{dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ? dataEvaluate?.form?.name : "-"}</span></Typography>
                        }
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Grid item md={12} xs={12}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Typography variant="h2" fontWeight={600} color="#404349" fontSize={30} lineHeight={1.495}>
                                        {dataEvaluate?.editor === "evaluator" ?
                                            t("evaluation.nameManage")
                                            :
                                            dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ?
                                                dataEvaluate?.form?.name
                                                : null
                                        }
                                    </Typography>
                                    <Box sx={{ flex: 2 }}></Box>
                                    {
                                        dataEvaluate?.button?.can_start === true ?
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <Box>
                                                    <Button onClick={(e) => onStart(dataEvaluate?.form_evaluate_id)} startIcon={<StartIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained" >{t("label.start")}</Button>
                                                </Box>
                                            </Box>
                                            : dataEvaluate?.button?.can_start === false && dataEvaluate?.button?.start === true ?
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Box class={dataEvaluate?.button?.can_start === false && dataEvaluate?.button?.start === true ? `${classes.btnDisabled}` : ``}>
                                                        <Button onClick={(e) => onStart(dataEvaluate?.form_evaluate_id)} startIcon={<StartIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px", }} variant="contained" disabled={dataEvaluate?.button?.can_start !== true && dataEvaluate?.button?.start === true ? true : false} >{t("label.start")}</Button>
                                                    </Box>
                                                </Box>
                                                : !statusEdit ?
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        {
                                                            dataEvaluate?.status !== "approved" ?
                                                                dataEvaluate?.evaluate_step?.step.filter(item => item?.options?.reject === true && item?.is_current === true).length > 0 && dataEvaluate?.button?.can_reject === true ?
                                                                    <>
                                                                        <Box sx={{ paddingRight: "30px" }}>
                                                                            <Button onClick={e => setOpenConfirmRejectPerformanceEvaliation(true)} startIcon={<CancelIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained" color="red">{t("label.status.reject")}</Button>
                                                                        </Box>
                                                                        <DialogSendToApprove serial={serial} submitError={submitError} can_submit={dataEvaluate?.button?.can_submit} setActSave={e => setActSave(false)} loadDataDetail={getDetail} nameButton={t('label.approve')} iconApprove={true} />
                                                                    </>
                                                                    : dataEvaluate?.button?.can_reject === false ?
                                                                        <>
                                                                            <Box sx={{ paddingRight: "30px" }}>
                                                                                <Button startIcon={<CancelIcon />} sx={{ cursor: "no-drop", backgroundColor: "#BABABA", pointerEvents: "none", textTransform: "none", height: "45px", fontSize: "16px" }} variant="contained" color="red">{t("label.status.reject")}</Button>
                                                                            </Box>
                                                                            <DialogSendToApprove serial={serial} submitError={submitError} can_submit={dataEvaluate?.button?.can_submit} loadDataDetail={getDetail} setActSave={null} nameButton={t('label.approve')} iconApprove={true} type="approve" />
                                                                        </>
                                                                        : dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true && item.workflow_section.options.is_extend === true).length > 0 ?
                                                                            dataEvaluate?.editor === "other" ?
                                                                                null
                                                                                : dataEvaluate?.editor === "evaluator" ?
                                                                                    dataEvaluate?.evaluate_step?.sign_off_extend?.manager?.sign === true ?
                                                                                        null
                                                                                        :
                                                                                        <Box>
                                                                                            <Button onClick={handleCancel} startIcon={<Signoff />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                        </Box>
                                                                                    : dataEvaluate?.evaluate_step?.sign_off_extend?.self?.sign === true ?
                                                                                        null
                                                                                        :
                                                                                        <Box>
                                                                                            <Button onClick={handleCancel} startIcon={<Signoff />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                        </Box>
                                                                            : dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ?
                                                                                dataEvaluate?.editor === "other" ?
                                                                                    null
                                                                                    : dataEvaluate?.editor === "evaluator" ?
                                                                                        dataEvaluate?.evaluate_step?.sign_off?.manager?.sign === true ?
                                                                                            null
                                                                                            : dataEvaluate?.button?.can_submit === true ?
                                                                                                <Box>
                                                                                                    <Button onClick={handleCancel} startIcon={<Signoff />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                                </Box>
                                                                                                :
                                                                                                <Box>
                                                                                                    <Button startIcon={<Signoff />} sx={{ cursor: "no-drop", backgroundColor: "#BABABA", pointerEvents: "none", textTransform: "none", height: "45px", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                                </Box>
                                                                                        : dataEvaluate?.evaluate_step?.sign_off?.self?.sign === true ?
                                                                                            null
                                                                                            : dataEvaluate?.button?.can_submit === true ?
                                                                                                <Box>
                                                                                                    <Button onClick={handleCancel} startIcon={<Signoff />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                                </Box>
                                                                                                :
                                                                                                <Box>
                                                                                                    <Button startIcon={<Signoff />} sx={{ cursor: "no-drop", backgroundColor: "#BABABA", pointerEvents: "none", textTransform: "none", height: "45px", fontSize: "16px" }} variant="contained">{t("label.signOff")}</Button>
                                                                                                </Box>
                                                                                : dataEvaluate?.editor === "other" ?
                                                                                    null
                                                                                    :
                                                                                    <>
                                                                                        <Box class={dataEvaluate?.button?.can_edit !== true ? `${classes.btnDisabled} ${classes.btnNotDisabled}` : `${classes.btnNotDisabled}`}>
                                                                                            <Button onClick={onEdit} startIcon={<EditIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px", borderColor: "#5DA196" }} variant="outlined" disabled={dataEvaluate?.button?.can_edit !== true ? true : false} >{t("label.edit")}</Button>
                                                                                        </Box>
                                                                                        <DialogSendToApprove serial={serial} submitError={submitError} can_submit={dataEvaluate?.button?.can_submit} setActSave={e => setActSave(false)} loadDataDetail={getDetail} nameButton={t('label.sendToApprove')} />
                                                                                    </>
                                                                : null
                                                        }
                                                    </Box>
                                                    :
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        <Box sx={{ paddingRight: "30px" }}>
                                                            <Button onClick={onCancel} startIcon={<CancelIcon />} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained" color="red">{t("label.cancel")}</Button>
                                                        </Box>
                                                        <Box className={checkDataSave() === true ? `${classes.btnDisabled}` : ""}>
                                                            <Button onClick={onSave} startIcon={<SaveIcon />} disabled={checkDataSave()} sx={{ height: "45px", textTransform: "none", fontSize: "16px" }} variant="contained">{t("label.save")}</Button>
                                                        </Box>
                                                    </Box>
                                    }
                                </Box>
                                {submitError && actSave ?
                                    <Box pt="30px">
                                        <Box sx={{ background: "rgba(86, 125, 244, 0.1)", border: "1px solid #567DF4", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                            <ErrorIcon></ErrorIcon>
                                            <Typography fontSize={18} lineHeight="19.8px" color="#567DF4" pl="10px">
                                                {t('evaluation.warning')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    : dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true && item.status === "wait").length > 0 ?
                                        dataDisplay?.result === "pass" ?
                                            <Box pt="30px">
                                                <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                                    <Pass></Pass>
                                                    <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px">
                                                        {dataEvaluate?.employee?.fullname + " " + t('evaluation.displayPass')}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            : dataDisplay?.result === "not_pass" ?
                                                <Box pt="30px">
                                                    <Box sx={{ background: "#FAEFEE", border: "1px solid #CC6058", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                                        <NotPass></NotPass>
                                                        <Typography fontSize={18} lineHeight="19.8px" color="#CC6058" pl="10px">
                                                            {dataEvaluate?.employee?.fullname + " " + t('evaluation.displayNotPass')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                : dataDisplay?.result === "extend" ?
                                                    <Box pt="30px">
                                                        <Box sx={{ background: "#FDF8F0", border: "1px solid #E3A34A", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                                            <Extension></Extension>
                                                            <Typography fontSize={18} lineHeight="19.8px" color="#E3A34A" pl="10px">
                                                                {dataEvaluate?.employee?.fullname + " " + t('evaluation.displayExtension') + " " + Util.dateDayFormatAdmin(dataDisplay?.extend_date)}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    : null
                                        : dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ?
                                            dataDisplay?.result === "pass" ?
                                                <Box pt="30px">
                                                    <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                                        <Pass></Pass>
                                                        <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px">
                                                            {dataEvaluate?.employee?.fullname + " " + t('evaluation.displayPass')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                : dataDisplay?.result === "not_pass" ?
                                                    <Box pt="30px">
                                                        <Box sx={{ background: "#FAEFEE", border: "1px solid #CC6058", borderRadius: "5px", display: "flex", alignItems: "center", padding: "20px" }}>
                                                            <NotPass></NotPass>
                                                            <Typography fontSize={18} lineHeight="19.8px" color="#CC6058" pl="10px">
                                                                {dataEvaluate?.employee?.fullname + " " + t('evaluation.displayNotPass')}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    : null
                                            : null}
                                <Grid container item pb={2} pt={2}>
                                    <Grid item xs sm md lg>
                                        <Card sx={{ height: 1, "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)", "border-radius": "10px" }}>
                                            <CardContent sx={{ padding: "20px" }}>
                                                <Grid container mb="20px">
                                                    <Grid item lg={12} xs={12} display="flex" alignItems="center">
                                                        <Typography variant="h3" fontWeight={600} color="#404349">
                                                            {dataEvaluate?.editor === "evaluator" ?
                                                                dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ?
                                                                    dataEvaluate?.form?.name
                                                                    : null
                                                                :
                                                                t('evaluation.evaluationInformation')
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container mt={2} display="flex" alignItems="center">
                                                        <Grid item display="flex" alignItems="center" mr="10px">
                                                            <CalendarIcon class={`${classes.fillBlack}`}></CalendarIcon>
                                                        </Grid>
                                                        <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                            <Box >
                                                                <Typography fontSize={18} lineHeight={1.1} color="#404349">
                                                                    {dataEvaluate?.editor === "evaluator" ? t('evaluation.period') : t('evaluation.evaluationCycle')}: {dateFormat(dataEvaluate?.form?.start_date)}-{dateFormat(dataEvaluate?.form?.end_date)}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container>

                                                    <Grid item lg={12} xs={12} display="flex" >
                                                        <Grid item xs={6} display="flex" flexDirection="column">
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                                {/* {dataEvaluate?.editor === "evaluator" ? */}
                                                                {t('evaluation.candidateProfile')}
                                                                {/* :
                                                                    t('evaluation.myProfile')
                                                                } */}
                                                            </Typography>
                                                            <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                                <Grid
                                                                    item
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    mr={3}
                                                                >
                                                                    <Avatar
                                                                        src={dataEvaluate?.employee?.photo}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 50,
                                                                            height: 50,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs sm md lg>
                                                                    <Grid container mb="3px" display="flex" alignItems="center" justifyContent="space-between">
                                                                        <Grid item >
                                                                            <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                                {formatData(dataEvaluate?.employee?.fullname, "-")}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item pr="30px">
                                                                            <Box onClick={onOpenMoreInfo} sx={{ cursor: "pointer" }} display="flex" alignItems="center">
                                                                                <MoreInfoIcon style={{ width: "20px", height: "20px" }} />
                                                                                <Typography pl="5px" fontSize={14} lineHeight="24px" fontWeight={400} color="primary">
                                                                                    {Util.formatData(dataEvaluate?.button?.button_moreinfo, t('label.moreInfo'))}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                            <Box display="flex" flexDirection="column" justifyContent="center">
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                        <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(dataEvaluate?.employee?.position, "-")} ({Util.formatData(datePosition, t('label.dateWork'))})</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                        <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{formatData(dataEvaluate?.employee?.organization, "-")}</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.startDate`)} placement="top">
                                                                                        <DateIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></DateIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.dateDayFormatAdmin(dataEvaluate?.employee?.employee_start_at, "-")} ({Util.formatData(dateEmpoloyee, t('label.dateWork'))})</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Box sx={{ borderLeft: "1px solid #E5E5E5" }}></Box>
                                                        {/* <Grid item xs={6} display="flex"> */}
                                                        <Grid item xs={6} display="flex" flexDirection="column" pl="30px">
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                                {/* {dataEvaluate.editor === "evaluator" ? */}
                                                                {t('evaluation.evaluationManage')}
                                                                {/* :
                                                                    t('evaluation.myEvaluator')
                                                                } */}
                                                            </Typography>
                                                            <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                                <Grid
                                                                    item
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    mr={3}
                                                                >
                                                                    <Avatar
                                                                        src={dataEvaluate?.evaluator?.photo}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 50,
                                                                            height: 50,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs sm md lg>
                                                                    <Grid container mb="3px">
                                                                        <Grid item>
                                                                            <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                                {formatData(dataEvaluate?.evaluator?.fullname, "-")}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                            <Box display="flex" flexDirection="column" justifyContent="center">
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                        <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349" >{formatData(dataEvaluate?.evaluator?.position, "-")}</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                        <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349" >{formatData(dataEvaluate?.evaluator?.organization, "-")}</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        {/* </Grid> */}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <Divider variant="middle" />
                                            <CardContent sx={{ padding: "20px", position: "relative" }}>
                                                <Grid container mt={0}>
                                                    <Grid
                                                        item
                                                        display="flex"
                                                        sx={{
                                                            flexFlow: "column",
                                                        }}
                                                    >
                                                        <Typography variant="h3" fontWeight={600} color="#404349">{t('evaluation.evaluationProcess')}</Typography>
                                                    </Grid>
                                                </Grid>

                                                <Grid container mt={1} display="flex" alignItems="center">
                                                    <Grid item mr="10px" display="flex" alignItems="center">
                                                        <CalendarIcon class={`${classes.fillBlack}`}></CalendarIcon>
                                                    </Grid>
                                                    <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                        <Box >
                                                            <Typography fontSize={18} lineHeight={1.1} color="#404349">
                                                                {t('evaluation.signOffDueDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.due_date), "-")}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                {/* status box */}
                                                <Grid container mt={2}>
                                                    <Grid item xs={12} display="flex" className={classes.swiperStyles}>
                                                        {dataEvaluate?.evaluate_step?.step !== undefined && dataEvaluate?.evaluate_step?.step !== null && dataEvaluate?.evaluate_step?.step.length > 0 ?
                                                            <Swiper
                                                                slidesPerView={4}
                                                                // spaceBetween={30}
                                                                slidesPerGroup={4}
                                                                loop={false}
                                                                // loopFillGroupWithBlank={true}
                                                                pagination={{
                                                                    clickable: true,
                                                                    type: "fraction"
                                                                }}
                                                                navigation={true}
                                                                modules={[Pagination, Navigation]}
                                                                className="mySwiper"
                                                            // className={classes.swiperStyles}
                                                            // style={styles.swiperStyles}
                                                            >
                                                                <Box sx={{
                                                                    width: "100%", display: "flex", alignItems: "center"
                                                                }}>
                                                                    {dataEvaluate?.evaluate_step?.step.map((loRow, index) => (
                                                                        <SwiperSlide>
                                                                            <>
                                                                                <div
                                                                                    style={{
                                                                                        // maxWidth: "235px",
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        background:
                                                                                            loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                                "#5DA1961A"
                                                                                                : loRow?.is_current === true ?
                                                                                                    "#F7B2541A"
                                                                                                    : loRow?.status === "approve" ?
                                                                                                        "#5DA1961A"
                                                                                                        : loRow?.status === "wait" ?
                                                                                                            "#FFFFFF"
                                                                                                            : "#FFFFFF",
                                                                                        border:
                                                                                            loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                                "1px solid #5DA196"
                                                                                                : loRow?.is_current === true ?
                                                                                                    "1px solid #F7B254"
                                                                                                    : loRow?.status === "approve" ?
                                                                                                        "1px solid #5DA196"
                                                                                                        : loRow?.status === "wait" ?
                                                                                                            "1px solid #DADADA"
                                                                                                            : "1px solid #DADADA",
                                                                                        borderRadius: "5px",
                                                                                        position: "relative",
                                                                                        // paddingBottom: "25px"

                                                                                    }}
                                                                                >
                                                                                    <Box
                                                                                        sx={{ p: 1, display: "flex", alignItems: "start" }}
                                                                                    >
                                                                                        <Box
                                                                                            mt="4px"
                                                                                            style={{
                                                                                                background:
                                                                                                    loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                                        "#5DA196"
                                                                                                        : loRow?.is_current === true ?
                                                                                                            "#F7B254"
                                                                                                            : loRow?.status === "approve" ?
                                                                                                                "#5DA196"

                                                                                                                : loRow?.status === "wait" ?
                                                                                                                    "#FAFAFA" : "#FAFAFA",
                                                                                                border:
                                                                                                    loRow?.is_current === true || loRow?.status === "approve" ?
                                                                                                        "none" : "1px dashed #C4C4C4",
                                                                                                borderRadius: "50%",
                                                                                                width: "30px",
                                                                                                height: "30px",
                                                                                            }}
                                                                                            sx={{
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "center",
                                                                                            }}
                                                                                        >
                                                                                            {/* <CheckIcon></CheckIcon> */}
                                                                                            {
                                                                                                loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                                    <ApprovedIcon></ApprovedIcon>
                                                                                                    : loRow?.is_current === true ?
                                                                                                        <DraftIcon></DraftIcon>
                                                                                                        : loRow?.status === "approve" ?
                                                                                                            <ApprovedIcon></ApprovedIcon>

                                                                                                            : null
                                                                                            }
                                                                                        </Box>
                                                                                        <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                                                                            <Typography fontSize="18" fontWeight="600"
                                                                                                sx={{
                                                                                                    color:
                                                                                                        loRow?.is_current === true ||
                                                                                                            loRow?.status === "approve" ?
                                                                                                            "#404349"
                                                                                                            : "#C4C4C4"
                                                                                                }}
                                                                                            >
                                                                                                {loRow?.name}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box
                                                                                        sx={{
                                                                                            px: 1,
                                                                                            paddingRight: "0px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                        }}
                                                                                    >
                                                                                        {/* <Box
                                                                                    style={{
                                                                                        width: "37px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                        <Box sx={{ paddingLeft: "30px", ml: 2, display: "flex", alignItems: "baseline", width: "100%", }}>
                                                                                            <Typography variant="h6" fontWeight="400"
                                                                                                sx={{
                                                                                                    color:
                                                                                                        loRow?.is_current === true ||
                                                                                                            loRow?.status === "approve" ?
                                                                                                            "#404349"
                                                                                                            : "#C4C4C4"
                                                                                                }}>
                                                                                                {t('label.by')}<span>&nbsp;</span>
                                                                                            </Typography>
                                                                                            <Box sx={{ width: "100%", }}>
                                                                                                {loRow?.options?.assignee !== undefined && loRow?.options?.assignee !== null && loRow?.options?.assignee.length > 0 ?
                                                                                                    loRow?.options?.assignee.map((item) => (
                                                                                                        <Box sx={{ width: "calc(100% - 44px)", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", }}>
                                                                                                            <Typography variant="h6" fontWeight="400"
                                                                                                                sx={{
                                                                                                                    width: item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ? "calc(100% - 25px)" : "calc(100% - 10px)",
                                                                                                                    textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap",
                                                                                                                    color:
                                                                                                                        loRow?.is_current === true ||
                                                                                                                            loRow?.status === "approve" ?
                                                                                                                            "#404349"
                                                                                                                            : "#C4C4C4"
                                                                                                                }}>
                                                                                                                {item.assignee}
                                                                                                            </Typography>
                                                                                                            {item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ?
                                                                                                                <Box style={{ position: "absolute", right: 0, top: 0, margin: "2px 6px 6px 0px", }}>
                                                                                                                    <div style={{ width: "max-content" }}>
                                                                                                                        <BootstrapTooltip
                                                                                                                            placement="top"
                                                                                                                            arrow
                                                                                                                            title={t('label.proxyBy') + "" + Util.formatData(item?.proxy_by, "-")}
                                                                                                                        >
                                                                                                                            <InfoIcon style={{ cursor: "pointer" }} />
                                                                                                                        </BootstrapTooltip>
                                                                                                                        {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                                                    </div>
                                                                                                                </Box> : null}
                                                                                                        </Box>
                                                                                                    ))
                                                                                                    :
                                                                                                    <Typography variant="h6" fontWeight="400"
                                                                                                        sx={{
                                                                                                            color:
                                                                                                                loRow?.is_current === true ||
                                                                                                                    loRow?.status === "approve" ?
                                                                                                                    "#404349"
                                                                                                                    : "#C4C4C4"
                                                                                                        }}>
                                                                                                        {"-"}
                                                                                                    </Typography>
                                                                                                }
                                                                                            </Box>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box
                                                                                        sx={{
                                                                                            px: 1,
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                        }}
                                                                                    >
                                                                                        {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                        <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                            <Typography variant="h6" fontWeight="400"
                                                                                                sx={{
                                                                                                    color:
                                                                                                        loRow?.is_current === true ||
                                                                                                            loRow?.status === "approve" ?
                                                                                                            "#404349"
                                                                                                            : "#C4C4C4"
                                                                                                }}>
                                                                                                {/* {t('label.formStatus')}: {formatData(loRow?.status, "Not Started")} */}
                                                                                                {t('label.formStatus')}: {loRow?.is_current === true && loRow?.status === "approve" ? t('label.completed') : loRow?.is_current === true ? t('label.inProgress') : loRow?.status === "approve" ? t('label.completed') : t('label.notStarted')}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box
                                                                                        sx={{
                                                                                            px: 1,
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                        }}
                                                                                    >
                                                                                        {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                        <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                            <Typography variant="h6" fontWeight="400"
                                                                                                sx={{
                                                                                                    color:
                                                                                                        loRow?.is_current === true ||
                                                                                                            loRow?.status === "approve" ?
                                                                                                            "#404349"
                                                                                                            : "#C4C4C4"
                                                                                                }}>
                                                                                                {t('evaluation.submittedDate')}: {formatData(dateDayFormat(loRow?.update_at), "-")}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box
                                                                                        sx={{
                                                                                            px: 1,
                                                                                            pb: 1,
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                        }}
                                                                                    >
                                                                                        {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                        <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                            <Typography variant="h6" fontWeight="400"
                                                                                                sx={{
                                                                                                    color:
                                                                                                        loRow?.is_current === true ||
                                                                                                            loRow?.status === "approve" ?
                                                                                                            "#404349"
                                                                                                            : "#C4C4C4"
                                                                                                }}>
                                                                                                {t('evaluation.dueDate')}: {formatData(dateDayFormat(loRow?.end_date), "-")}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            right: 0,
                                                                                            top: 0,
                                                                                            margin: 6,
                                                                                        }}
                                                                                    >
                                                                                        <div style={{ width: "max-content" }}>
                                                                                            <BootstrapTooltip
                                                                                                placement="top"
                                                                                                arrow
                                                                                                title={formatData(loRow?.tooltip, "-")}
                                                                                            >
                                                                                                <InfoIcon style={{ cursor: "pointer" }} />
                                                                                            </BootstrapTooltip>
                                                                                            {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                        </div>
                                                                                    </Box>
                                                                                </div>
                                                                                {/* connector */}
                                                                                <Box
                                                                                    id="connector"
                                                                                    sx={{
                                                                                        borderTop: dataEvaluate?.evaluate_step?.step.length === index + 1 ? "" : "3px dashed #E5E5E5",
                                                                                        width: "100%",
                                                                                        maxWidth: "65px",
                                                                                        // "&:last-child": {
                                                                                        //     borderTop: "none",
                                                                                        //     width: "0px"
                                                                                        // }
                                                                                    }}
                                                                                ></Box>
                                                                            </>
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Box>
                                                            </Swiper>
                                                            : null
                                                        }
                                                    </Grid>
                                                    {checkeNextAction !== undefined && checkeNextAction !== null && checkeNextAction.length > 0 && dataEvaluate?.status !== "approved" ?
                                                        <Grid item xs={12} display="flex" pt="15px !important" sx={{ "svg": { width: "18px", height: "18px" } }}>
                                                            <InfoIcon />
                                                            <Typography ml="12px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "400" }} >{t('evaluation.nextAction')}: </Typography>
                                                            {checkeNextAction.map((rs, index) => (
                                                                rs?.is_current === true ?
                                                                    <Typography ml="5px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "300" }} >{t('evaluation.waitingFor')} {rs?.name}</Typography>
                                                                    :
                                                                    <Typography ml="5px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "300" }} >-</Typography>
                                                            ))
                                                            }
                                                        </Grid>
                                                        : null
                                                    }
                                                </Grid>
                                                {/* end status box */}

                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Box pt="18px" width="100%" display="flex" sx={{ "flex-wrap": "nowrap !important" }}>
                                <Box width={`${getWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))}%`} pr="15px">
                                    <Card sx={{ height: 1, "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }}>
                                        <RatingSummary getFirstWidth={getFirstWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))} getNextWidth={getNextWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))} checkeNextAction={checkeNextAction} editor={dataEvaluate?.editor} datas={dataEvaluate?.probation_summary?.rating_summary} dataPercent={dataEvaluate?.probation_summary?.rating_summary_percent} config={dataEvaluate?.evaluate_template_config?.score_decimal} listWorkflow={dataEvaluate?.workflow_section} />
                                    </Card>
                                </Box>
                                <Box width={`${100 - getWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))}%`} pl="15px">
                                    <Card sx={{ height: 1, overflow: "unset", "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }}>
                                        <TotalAchievements cycle={dataEvaluate?.form?.options?.cycle} emp_id={dataEvaluate?.employee?.serial} getFirstWidth={getFirstWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))} getNextWidth={getNextWidth(Util.formatData(dataEvaluate?.workflow_section?.length, 3))} datas={dataEvaluate?.probation_summary?.achievement_total} />
                                    </Card>
                                </Box>
                            </Box>
                        </Grid>
                        {
                            dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 && Util.formatData(dataEvaluate?.evaluate_step?.sign_off_extend, false) !== false ?
                                <>
                                    <Grid item>
                                        <Divider />
                                    </Grid>
                                    <Grid container item>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            flexDirection="row"
                                            width="100%"
                                            justifyContent="space-between"
                                        >
                                            <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }} onClick={onSetSignOffExtend}>
                                                <div
                                                    className={`${classes.iconContainer}`}
                                                    style={{ background: "#2A8A71" }}
                                                >
                                                    <img src={signatures} alt="bannerImage" />
                                                </div>
                                                <Typography variant="h2" pl="20px" fontSize={30} lineHeight="33px" color="#404349">
                                                    {t('evaluation.evaluationSignaturesExtension')}
                                                </Typography>
                                            </Box>
                                            <Box height="24px">
                                                {signOffExtend === false ? <ChevronDown style={{ cursor: "pointer" }} onClick={onSetSignOffExtend} /> : <ChevronUp style={{ cursor: "pointer" }} onClick={onSetSignOffExtend} />}
                                            </Box>
                                        </Box>
                                        <Collapse in={signOffExtend} sx={{ width: "100%" }}>
                                            <Grid container item sx={{ display: "block" }}>
                                                <Box>
                                                    <Typography pt="20px" pb="32px" fontSize="18px" lineHeight={1.1} fontWeight="400" color="#404349">
                                                        {t('evaluation.subTilteEvaluationSignatures')}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ padding: "31px 0", background: "#FFFFFF", border: "1px solid #E4E4E4", "box-sizing": "border-box", borderRadius: "10px", display: "flex", "flex-direction": "row", justifyContent: "center" }}>
                                                    <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                        <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                            {t('evaluation.evaluatorSignature')}
                                                        </Typography>
                                                        <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                            {formatData(dataEvaluate?.evaluator?.fullname, "-")}
                                                        </Typography>
                                                        <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                            {t('evaluation.agreeToContentEvaluator')}
                                                        </Typography>
                                                        <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                            {dataEvaluate?.evaluate_step?.sign_off_extend !== undefined && dataEvaluate?.evaluate_step?.sign_off_extend !== null && dataEvaluate?.evaluate_step?.sign_off_extend !== "" ?
                                                                dataEvaluate?.evaluate_step?.sign_off_extend?.manager?.sign === true ?
                                                                    <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                        {dataEvaluate?.evaluate_step?.sign_off_extend?.manager?.fullname}
                                                                    </Typography>
                                                                    :
                                                                    <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                        {t('evaluation.notSignedYet')}
                                                                    </Typography>
                                                                :
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                    {t('evaluation.notSignedYet')}
                                                                </Typography>
                                                            }
                                                        </Box>
                                                        <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                            ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off_extend?.manager?.updated_at), "-")})
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                        <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                            {t('evaluation.candidateSignature')}
                                                        </Typography>
                                                        <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                            {formatData(dataEvaluate?.employee?.fullname, "-")}
                                                        </Typography>
                                                        <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                            {t('evaluation.agreeToContentEmployee')}
                                                        </Typography>
                                                        <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                            {dataEvaluate?.evaluate_step?.sign_off_extend !== undefined && dataEvaluate?.evaluate_step?.sign_off_extend !== null && dataEvaluate?.evaluate_step?.sign_off_extend !== "" ?
                                                                dataEvaluate?.evaluate_step?.sign_off_extend?.self?.sign === true ?
                                                                    <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                        {dataEvaluate?.evaluate_step?.sign_off_extend?.self?.fullname}
                                                                    </Typography>
                                                                    :
                                                                    <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                        {t('evaluation.notSignedYet')}
                                                                    </Typography>
                                                                :
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                    {t('evaluation.notSignedYet')}
                                                                </Typography>
                                                            }
                                                        </Box>
                                                        <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                            ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off_extend?.self?.updated_at), "-")})
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Collapse>
                                    </Grid>
                                </>
                                : null
                        }
                        <Grid item xs={12} sx={{ paddingTop: "30px !important" }}>
                            <Divider />
                        </Grid>
                        <Grid container item mb={evaluation === true || dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ? "30px" : "0px"} sx={{ pt: "0px!important" }}>
                            <Grid container >
                                <Grid item md={12} >
                                    {workloadFormSelect?.length > 0 ?
                                        <Grid container item mt={"30px"}>
                                            <Grid
                                                item
                                                display="flex"
                                                alignItems="center"
                                                flexDirection="row"
                                                justifyContent="space-between"
                                                width="100%"
                                            >
                                                <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }} onClick={onHideEvaluationChange}>
                                                    <div
                                                        className={`${classes.iconContainer}`}
                                                        style={{ background: "#2A8A71" }}
                                                    >
                                                        <img src={file} alt="bannerImage" />
                                                    </div>
                                                    <Typography variant="h2" pl="20px" fontSize={30} lineHeight="33px" color="#404349">
                                                        {t('evaluation.performanceEvaluationForm')}
                                                    </Typography>
                                                </Box>
                                                <Box height="24px">
                                                    {evaluation === false ? <ChevronDown style={{ cursor: "pointer" }} onClick={onHideEvaluationChange} /> : <ChevronUp style={{ cursor: "pointer" }} onClick={onHideEvaluationChange} />}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        : null}
                                </Grid>
                            </Grid>
                            <Collapse in={evaluation} sx={{ width: "100%" }}>
                                <Grid item lg={12} md={12} >
                                    {/* <Collapse in={hideEvaluation}> */}
                                    <Grid item md={12} mb="30px" sx={{ borderBottom: "1px solid #e4e4e4" }} pt="16px">
                                        <Grid container item alignItems="center">
                                            <Tabs
                                                value={value}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                onChange={handleChange}
                                                aria-label="Tabs"
                                                variant="scrollable"
                                                scrollButtons
                                                allowScrollButtonsMobile
                                                TabIndicatorProps={{
                                                    style: {
                                                        height: "8px",
                                                        fontSize: "20px",
                                                    },
                                                }}
                                            >
                                                {Datas !== undefined && Datas !== null && Datas.length > 0 ? Datas.map((loRow) => ( //  
                                                    loRow?.type === "result" ?
                                                        Util.formatData(loRow?.list_item, []).length > 0 ?
                                                            <Tab label={<span style={{ "font-size": "16px", display: "flex", color: actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "#5DA196" : "#939393" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "#5DA196" : "#939393" : "#CC6058" }}>{loRow?.type === "goal" ? t('evaluation.goalsEvaluation') : loRow?.type === "competency" ? t('evaluation.competencyEvaluation') : loRow.type === "probation" ? Util.formatData(loRow?.name, false) !== false ? loRow?.name : t('evaluation.probation') : loRow.type === "result" ? t('evaluation.result') : loRow.type === "custom" ? Util.formatData(loRow?.name, false) !== false ? loRow?.name : t('evaluation.customForm') : ""} {loRow?.type !== "idp" && loRow?.total !== undefined ? <Box ml={2} px="4px" height="20px" minWidth="20px" sx={{ background: actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : "#F7E7E6", borderRadius: "2px" }}><Typography fontSize={18} lineHeight="20px" fontWeight="500" color={actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "#5DA196" : "#939393" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "#5DA196" : "#939393" : "#CC6058"}>{loRow?.total}</Typography></Box> : null}</span>} value={loRow?.type === "custom" ? loRow?.type + loRow?.seq : loRow?.type} classes={{ root: classes.tab }} />
                                                            :
                                                            null
                                                        :
                                                        <Tab label={<span style={{ "font-size": "16px", display: "flex", color: actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "#5DA196" : "#939393" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "#5DA196" : "#939393" : "#CC6058" }}>{loRow?.type === "goal" ? t('evaluation.goalsEvaluation') : loRow?.type === "competency" ? t('evaluation.competencyEvaluation') : loRow.type === "probation" ? Util.formatData(loRow?.name, false) !== false ? loRow?.name : t('evaluation.probation') : loRow.type === "result" ? t('evaluation.result') : loRow.type === "custom" ? Util.formatData(loRow?.name, false) !== false ? loRow?.name : t('evaluation.customForm') : ""} {loRow?.type !== "idp" && loRow?.total !== undefined ? <Box ml={2} px="4px" height="20px" minWidth="20px" sx={{ background: actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "rgba(93, 161, 150, 0.15)" : "rgba(64, 67, 73, 0.15)" : "#F7E7E6", borderRadius: "2px" }}><Typography fontSize={18} lineHeight="20px" fontWeight="500" color={actSave === false ? value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? "#5DA196" : "#939393" : showTypeError[loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type] !== true ? value === loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type ? "#5DA196" : "#939393" : "#CC6058"}>{loRow?.total}</Typography></Box> : null}</span>} value={loRow?.type === "custom" ? loRow?.type + loRow?.seq : loRow?.type} classes={{ root: classes.tab }} />
                                                ))
                                                    : null}
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                    {Datas !== undefined && Datas !== null && Datas.length > 0 ? Datas.map((loRow, index) => (
                                        <>
                                            {loRow?.type === "result" ?
                                                <Grid container sx={{ display: value === `${loRow.type === "custom" ? loRow.type + loRow.seq : loRow.type}` ? 'block' : 'none' }}>
                                                    <Grid item sm={12} xs={12} pb="30px">
                                                        <Box>
                                                            <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{t('evaluation.result')}</Typography>
                                                        </Box>
                                                        {Util.formatData(loRow?.list_item, []).length > 0 ?
                                                            <Result statusEdit={statusEdit} callBack={callBack} editor={dataEvaluate?.editor} actSave={actSave} loRow={loRow?.list_item} />
                                                            :
                                                            null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                :
                                                <Grid container sx={{ display: value === `${loRow?.type === "custom" ? loRow?.type + loRow?.seq : loRow?.type}` ? 'block' : 'none' }}>
                                                    <Grid item sm={12} xs={12} pb="30px" sx={{ display: "flex", "flex-flow": "row", "justify-content": "space-between" }}>
                                                        {loRow?.type === "goal" ?
                                                            <Box>
                                                                <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }}>{t('evaluation.goalsEvaluation')}</Typography>
                                                                <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>{t('evaluation.totalGoals')}: {loRow?.total} {t('evaluation.unitGoals')} </Typography>
                                                            </Box>
                                                            : loRow?.type === "probation" ?
                                                                <Box>
                                                                    <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Probation"}</Typography>
                                                                    <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>Total {Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Probation"}: {loRow?.total} Items </Typography>
                                                                </Box>
                                                                : loRow?.type === "custom" ?
                                                                    <Box>
                                                                        <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Custom Form"}</Typography>
                                                                        <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>Total {Util.formatData(loRow?.name, false) !== false ? loRow?.name : "Custom Form"}: {loRow?.total} Items </Typography>
                                                                    </Box>
                                                                    :
                                                                    <Box>
                                                                        <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{t('evaluation.competencyEvaluation')}</Typography>
                                                                        <Typography fontSize={16} fontWeight="fontWeightLight" variant="label" color="#9E9E9E" sx={{ "text-transform": "capitalize" }}>{t('evaluation.totalCompetency')}: {loRow?.total} {t('evaluation.unitCompetencies')} </Typography>
                                                                    </Box>
                                                        }
                                                        {loRow?.type === "goal" && checkeNextAction?.options?.hide_score_self !== true ?
                                                            <Stack direction="row" spacing={2}>
                                                                <div>
                                                                    <Button
                                                                        sx={{ display: "flex", height: "45px", padding: "5px 11px" }}
                                                                        variant="dashed-solid"
                                                                        ref={anchorRef}
                                                                        id="composition-button"
                                                                        aria-controls={openMenus ? 'composition-menu' : undefined}
                                                                        aria-expanded={openMenus ? 'true' : undefined}
                                                                        aria-haspopup="true"
                                                                        onClick={handleToggle}
                                                                    >
                                                                        <Box sx={{ display: "flex", "align-items": "center", "text-transform": "none" }}>
                                                                            <BtnFilter />
                                                                            <Typography ml="10px" color="#404349">{t('competency.filters')}</Typography>
                                                                        </Box>
                                                                    </Button>
                                                                    <Popper
                                                                        open={openMenus}
                                                                        anchorEl={anchorRef.current}
                                                                        role={undefined}
                                                                        placement="bottom-start"
                                                                        transition
                                                                        disablePortal
                                                                        style={{ "z-index": "2" }}
                                                                    >
                                                                        {({ TransitionProps, placement }) => (
                                                                            <Grow
                                                                                {...TransitionProps}
                                                                                style={{
                                                                                    transformOrigin:
                                                                                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                                }}
                                                                            >
                                                                                <Paper sx={{ "margin-top": "5px !important" }}>
                                                                                    <ClickAwayListener onClickAway={handleClose}>
                                                                                        <MenuList
                                                                                            autoFocusItem={openMenus}
                                                                                            id="composition-menu"
                                                                                            aria-labelledby="composition-button"
                                                                                            onKeyDown={handleListKeyDown}
                                                                                        >

                                                                                            <Box px="16px" py="6px">
                                                                                                <FormGroup>
                                                                                                    <FormControlLabel control={<Checkbox indeterminate={checkIndeterminate()} onChange={e => changeGapGolas("all", loRow)} checked={checkAll()} />} label={t('competency.selectAll')} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolas("goalsSuccess", loRow)} checked={checkFilter.goalsSuccess} />} label={`Gap +`} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolas("goalsError", loRow)} checked={checkFilter.goalsError} />} label={`Gap -`} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolas("goalsNoGap", loRow)} checked={checkFilter.goalsNoGap} />} label={`No Gap`} />
                                                                                                </FormGroup>
                                                                                            </Box>
                                                                                        </MenuList>
                                                                                    </ClickAwayListener>
                                                                                </Paper>
                                                                            </Grow>
                                                                        )}
                                                                    </Popper>
                                                                </div>
                                                            </Stack>
                                                            : null}
                                                        {loRow?.type === "competency" && checkeNextAction?.options?.hide_score_self !== true ?
                                                            <Stack direction="row" spacing={2}>
                                                                <div>
                                                                    <Button
                                                                        sx={{ display: "flex", height: "45px", padding: "5px 11px" }}
                                                                        variant="dashed-solid"
                                                                        ref={anchorRefCompetency}
                                                                        id="composition-button"
                                                                        aria-controls={openMenusCompetency ? 'composition-menu' : undefined}
                                                                        aria-expanded={openMenusCompetency ? 'true' : undefined}
                                                                        aria-haspopup="true"
                                                                        onClick={handleToggleCompetency}
                                                                    >
                                                                        <Box sx={{ display: "flex", "align-items": "center", "text-transform": "none" }}>
                                                                            <BtnFilter />
                                                                            <Typography ml="10px" color="#393939">{t('competency.filters')}</Typography>
                                                                        </Box>
                                                                    </Button>
                                                                    <Popper
                                                                        open={openMenusCompetency}
                                                                        anchorEl={anchorRefCompetency.current}
                                                                        role={undefined}
                                                                        placement="bottom-start"
                                                                        transition
                                                                        disablePortal
                                                                        style={{ "z-index": "2" }}
                                                                    >
                                                                        {({ TransitionProps, placement }) => (
                                                                            <Grow
                                                                                {...TransitionProps}
                                                                                style={{
                                                                                    transformOrigin:
                                                                                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                                }}
                                                                            >
                                                                                <Paper sx={{ "margin-top": "5px !important" }}>
                                                                                    <ClickAwayListener onClickAway={handleCloseCompetency}>
                                                                                        <MenuList
                                                                                            autoFocusItem={openMenusCompetency}
                                                                                            id="composition-menu"
                                                                                            aria-labelledby="composition-button"
                                                                                            onKeyDown={handleListKeyDownCompetency}
                                                                                        >

                                                                                            <Box px="16px" py="6px">
                                                                                                <FormGroup>
                                                                                                    <FormControlLabel control={<Checkbox indeterminate={checkIndeterminateCompetency()} onChange={e => changeGapGolasCompetency("all", loRow)} checked={checkAllCompetency()} />} label={t('competency.selectAll')} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolasCompetency("goalsSuccess", loRow)} checked={checkFilterCompetency.goalsSuccess} />} label={`Gap +`} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolasCompetency("goalsError", loRow)} checked={checkFilterCompetency.goalsError} />} label={`Gap -`} />
                                                                                                    <FormControlLabel control={<Checkbox onChange={e => changeGapGolasCompetency("goalsNoGap", loRow)} checked={checkFilterCompetency.goalsNoGap} />} label={`No Gap`} />
                                                                                                </FormGroup>
                                                                                            </Box>
                                                                                        </MenuList>
                                                                                    </ClickAwayListener>
                                                                                </Paper>
                                                                            </Grow>
                                                                        )}
                                                                    </Popper>
                                                                </div>
                                                            </Stack>
                                                            : null}
                                                    </Grid>
                                                    {loRow?.type === "goal" ?
                                                        Util.formatData(loRow?.instruction, false) !== false ?
                                                            <Box pb="30px">
                                                                <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", alignItems: "center", padding: "15px" }}>
                                                                    <Megaphone></Megaphone>
                                                                    <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px" dangerouslySetInnerHTML={{ __html: loRow?.instruction }}>
                                                                        {/* {Util.formatData(loRow?.instruction, '')} */}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            : null
                                                        : loRow?.type === "competency" ?
                                                            Util.formatData(loRow?.instruction, false) !== false ?
                                                                <Box pb="30px">
                                                                    <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", alignItems: "center", padding: "15px" }}>
                                                                        <Megaphone></Megaphone>
                                                                        <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px" dangerouslySetInnerHTML={{ __html: loRow?.instruction }}>
                                                                            {/* {Util.formatData(loRow?.instruction, '')} */}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                                : null
                                                            : loRow?.type === "probation" ?
                                                                Util.formatData(loRow?.instruction, false) !== false ?
                                                                    <Box pb="30px">
                                                                        <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", alignItems: "center", padding: "15px" }}>
                                                                            <Megaphone></Megaphone>
                                                                            <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px" dangerouslySetInnerHTML={{ __html: loRow?.instruction }}>
                                                                                {/* {Util.formatData(loRow?.instruction, '')} */}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    : null
                                                                : null
                                                    }
                                                    {Util.formatData(loRow?.list_item, false) !== false && loRow?.list_item.length > 0 ? loRow.list_item.map((rs, id) => (
                                                        <ListData have_feedback_probation={dataEvaluate?.have_feedback_probation} have_feedback_competency={dataEvaluate?.have_feedback_competency} have_feedback_goal={dataEvaluate?.have_feedback_goal} dataEmpolyee={dataEvaluate?.employee} dataEmpolyeeOwner={dataEvaluate?.evaluator} reset={reset} setReset={changeReset} have_self_evaluation={dataEvaluate.have_self_evaluation} checkeNextAction={checkeNextAction} rs={rs} loRow={loRow} mainRow={mainData[index]?.list_item[id]} statusEdit={statusEdit} callBack={callBack} editor={dataEvaluate?.editor} submitError={submitError} actSave={actSave} formID={dataEvaluate?.form_evaluate_id} />
                                                    ))
                                                        :
                                                        <Grid item sx={styles.emty} >
                                                            <img src={emty} alt="emtyData"></img>
                                                            <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">
                                                                {loRow?.type === "goal" ?
                                                                    t('evaluation.emtyGoal')
                                                                    : loRow?.type === "competency" ?
                                                                        t('evaluation.emtyCompetency')
                                                                        : "Your evaluation has not been assigned yet."
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            }
                                        </>
                                    ))
                                        : null
                                    }
                                </Grid>
                            </Collapse>
                        </Grid>
                    </Grid>
                    {
                        dataEvaluate?.evaluate_step?.step.filter(item => item.type === "signoff" && item.is_current === true).length > 0 ?
                            <>
                                <Grid item>
                                    <Divider />
                                </Grid>
                                <Grid container item mt={"30px"} mb="30px">
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        flexDirection="row"
                                        width="100%"
                                        justifyContent="space-between"
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }} onClick={onSetSignOff}>
                                            <div
                                                className={`${classes.iconContainer}`}
                                                style={{ background: "#2A8A71" }}
                                            >
                                                <img src={signatures} alt="bannerImage" />
                                            </div>
                                            <Typography variant="h2" pl="20px" fontSize={30} lineHeight="33px" color="#404349">
                                                {t('evaluation.evaluationSignatures')}
                                            </Typography>
                                        </Box>
                                        <Box height="24px">
                                            {signOff === false ? <ChevronDown style={{ cursor: "pointer" }} onClick={onSetSignOff} /> : <ChevronUp style={{ cursor: "pointer" }} onClick={onSetSignOff} />}
                                        </Box>
                                    </Box>
                                    <Collapse in={signOff} sx={{ width: "100%" }}>
                                        <Grid container item sx={{ display: "block" }}>
                                            <Box>
                                                <Typography pt="20px" pb="32px" fontSize="18px" lineHeight={1.1} fontWeight="400" color="#404349">
                                                    {t('evaluation.subTilteEvaluationSignatures')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ padding: "31px 0", background: "#FFFFFF", border: "1px solid #E4E4E4", "box-sizing": "border-box", borderRadius: "10px", display: "flex", "flex-direction": "row", justifyContent: "center" }}>
                                                <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                    <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                        {t('evaluation.evaluatorSignature')}
                                                    </Typography>
                                                    <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                        {formatData(dataEvaluate?.evaluator?.fullname, "-")}
                                                    </Typography>
                                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                        {t('evaluation.agreeToContentEvaluator')}
                                                    </Typography>
                                                    <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                        {dataEvaluate?.evaluate_step?.sign_off !== undefined && dataEvaluate?.evaluate_step?.sign_off !== null && dataEvaluate?.evaluate_step?.sign_off !== "" ?
                                                            dataEvaluate?.evaluate_step?.sign_off?.manager?.sign === true ?
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                    {dataEvaluate?.evaluate_step?.sign_off?.manager?.fullname}
                                                                </Typography>
                                                                :
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                    {t('evaluation.notSignedYet')}
                                                                </Typography>
                                                            :
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                {t('evaluation.notSignedYet')}
                                                            </Typography>
                                                        }
                                                    </Box>
                                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                        ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off?.manager?.updated_at), "-")})
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ "width": "calc(50% - 25px)", "max-width": "611px", "text-align": "center", margin: "0 25px" }} px="25px">
                                                    <Typography fontSize="16px" lineHeight="24px" fontWeight="400" color="#A0A0A0" pb="5px">
                                                        {t('evaluation.candidateSignature')}
                                                    </Typography>
                                                    <Typography fontSize="20px" lineHeight="24px" fontWeight="500" color="#5DA196" pb="15px">
                                                        {formatData(dataEvaluate?.employee?.fullname, "-")}
                                                    </Typography>
                                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#404349" sx={{ "text-align": "center" }}>
                                                        {t('evaluation.agreeToContentEmployee')}
                                                    </Typography>
                                                    <Box sx={{ "padding-top": statusEdit ? "20px" : "37px", "padding-bottom": statusEdit ? "10px" : "26px", '& div > input': { "text-align": "center", "font-size": "18px", "line-height": "26.91px", padding: "17px 14px", color: "#404349" } }}>
                                                        {dataEvaluate?.evaluate_step?.sign_off !== undefined && dataEvaluate?.evaluate_step?.sign_off !== null && dataEvaluate?.evaluate_step?.sign_off !== "" ?
                                                            dataEvaluate?.evaluate_step?.sign_off?.self?.sign === true ?
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="500" color="#404349" sx={{ textTransform: "uppercase" }}>
                                                                    {dataEvaluate?.evaluate_step?.sign_off?.self?.fullname}
                                                                </Typography>
                                                                :
                                                                <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                    {t('evaluation.notSignedYet')}
                                                                </Typography>
                                                            :
                                                            <Typography fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                                {t('evaluation.notSignedYet')}
                                                            </Typography>
                                                        }
                                                    </Box>
                                                    <Typography fontSize="18px" lineHeight="19.8px" fontWeight="400" color="#A0A0A0">
                                                        ({t('evaluation.signOffDate')}: {formatData(dateDayFormat(dataEvaluate?.evaluate_step?.sign_off?.self?.updated_at), "-")})
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Collapse>
                                </Grid>
                            </>
                            : null
                    }
                    <ConfirmDialog open={isConfirmCancelDialogOpen} warning={true} doConfirm={handleConfirmCancelList} setValue={handleConfirmCancelDialog} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <SimpleDialog open={isSuccessSaveDialogOpen} setValue={closeSuccessSaveDialog} save={true} text={t('label.changesSuccessfully')} subTitle="" noClose={true} />
                    <ConfirmDialog open={discardDialog} warning={true} submit={true} twoText={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('evaluation.submitSignoff')} text={language === "en-US" ? t('evaluation.areYouSureSignoff') + '<br>' + dataEvaluate?.form?.name + '?' : "คุณแน่ใจหรือไม่ว่าต้องการ ลงนามรับทราบและส่งแบบประเมินผล" + dataEvaluate?.form?.name + " " + "ให้เสร็จสมบูรณ์?"} />
                    <Congrtulations open={isSuccessSignoffDialogOpen} setValue={handleSignoffDialog} name={dataEvaluate?.form?.name} editor={dataEvaluate?.editor} nameEmployee={dataEvaluate?.employee?.fullname} formID={dataEvaluate?.form_evaluate_id} />
                    {/* <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} /> */}
                    <SimpleDialog open={isSuccessRejectDialogOpen} setValue={closeRejectSuccess} text="Reject successfully." subTitle="" noClose={true} />
                    <MessageDialogRejectPerformanceEvaliation open={openMessageDialogRejectPerformanceEvaliation} tryAgain={tryAgain} setValue={setOpenMessageDialogRejectPerformanceEvaliation} text={t('inbox.label.dialog.rejectUnsuccessfully')} title={t('inbox.label.dialog.fail')} />
                    <ConfirmRejectPerformanceEvaliation action={actionReject} open={openConfirmRejectPerformanceEvaliation} setValue={setOpenConfirmRejectPerformanceEvaliation} type="reject" text="Are you sure to reject this request?" title="Confirmation of  reject request" />
                    <MoreInfo open={openMoreInfo} close={onCloseMoreInfo} formID={dataEvaluate?.form_evaluate_id} name={Util.formatData(dataEvaluate?.button?.button_moreinfo, t('label.moreInfo'))} />
                </Container >
            </Box >
            {Util.ScrollToTop()}
        </Box >
    )
};
export default PerformanceEvaliationDetail;
